import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { map } from 'rxjs/operators';

import { HelperService } from 'src/app/helper.service';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { BaseService } from 'src/app/services/base.service';

@Injectable({
  providedIn: 'root',
})
export class ExportGriddingService extends BaseService{
  
 private API_ANALYSIS_MANAGEMENT_URL = this.API_BASE_URL + "analysis-management";
 
    constructor(
      private httpClient: HttpClient,
      public snackBar: MatSnackBar,
      public helper: HelperService,
      public nav: NavBarComponent,
  ) {
    super();
  }

  postExportGriddingAsExcel(tenantId: number, analysisType?: string[] | null): Observable<Blob> {
  const body: any = { tenantId };
  
  if (analysisType && analysisType.length > 0) {
    body.analysisType = analysisType;
  }
  
  // console.log('Export request body:', body);
  // console.log('Request URL:', this.API_ANALYSIS_MANAGEMENT_URL + '/gridding/dates/export');
  // console.log('Auth token:', localStorage.getItem('token') || sessionStorage.getItem('token'));
  
  return this.httpClient.post(this.API_ANALYSIS_MANAGEMENT_URL + '/gridding/dates/export', body, { 
    responseType: 'blob',
    observe: 'response'
  })
    .pipe(
      map((response: HttpResponse<Blob>) => response.body!),
      catchError((err) => {
        console.error('Export error:', err);
        console.error('Error status:', err.status);
        console.error('Error message:', err.message);
        console.error('Error body:', err.error);
        this.hasError.next(true);
        this.snackBar.open(`Error ${err.status}: ${err.message || 'Export failed'}`, 'close', {
          duration: 5000,
        });
        this.nav.toggleLoading(false);
        this.hasError.next(false);
        return this.errorHandler(err);
      })
    );
}

}
